module.exports = __webpack_public_path__ + "static/media/4ODA1.b84436c6.jpg";